//----------------------
// <auto-generated>
//     Generated using Aya Client Generator [Version 1.0.2]
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export enum AutoMatchStatusType {
    None = 0,
    Failed = 1,
    Passed = 2,
    ReviewNeeded = 3,
    RuleConflict = 4,
    MissingMetadata = 5,
    Error = 6,
}
